
import { Component, Prop, Vue } from "vue-property-decorator";
import { assetsUrl } from "@/env";

@Component({ name: "ScorePinAvg" })
export default class ScorePinAvg extends Vue {
  @Prop({ required: false, type: Boolean, default: false })
  isGroup: boolean | undefined;
  @Prop({ required: false, type: Boolean, default: false })
  isExample: boolean | undefined;
  @Prop({ required: true, type: Number })
  scorePercentage: number | undefined;
  @Prop({ required: false, type: Number })
  score: number | undefined;
  @Prop({ required: false, type: Boolean })
  displayIndivScore: boolean | undefined;
  @Prop({ required: false, type: Boolean })
  displayGroupScore: boolean | undefined;
  @Prop({ required: true, type: Number })
  scoreNumber!: number;
  @Prop({ required: false, type: Number, default: 0 })
  sameScore: number | undefined;
  @Prop({ required: false, type: Boolean, default: false })
  isAvg: boolean | undefined;
  @Prop({ required: false, type: Boolean, default: false })
  isSequencePageDisplay: boolean | undefined;

  data(): any {
    return {
      sameScoreB: true,
      componentKey: 0,
    };
  }

  forceRerender() {
    this.componentKey += 1;
  }

  created(): void {
    this.sameScoreB = true;
  }

  mounted(): void {
    this.sameScoreB = true;
    let allNormalBest = document.querySelectorAll("#normalBest");
    let allNormalAvg = document.querySelectorAll("#normalAvg");
    let normalBest = allNormalBest[allNormalBest.length - 1];
    let normalAvg = allNormalAvg[allNormalBest.length - 1];
    let rectBest = normalBest.getClientRects();
    let rectAvg = normalAvg.getClientRects();
    if (rectBest[0] === undefined) {
      this.sameScoreB = false;
    } else {
      if (rectBest[0].left <= rectAvg[0].right) {
        this.sameScoreB = false;
      } else this.sameScoreB = true;
    }
  }

  getPinStyle(scorePercentage: number): string {
    return `left: calc(${scorePercentage}% - ${
      this.isExample ? "12px" : this.isGroup ? "22px" : "12px"
    }); `;
  }

  getPinClassName(): string {
    return `score-pin ${this.isGroup ? "group-pin" : "single-pin"} $`;
  }

  getAvgImg(): string {
    return `${assetsUrl}/svg/icone_groupe_sans_fleche.svg`;
  }

  getGroupImgSrc(): string {
    let number = this.scoreNumber;
    if (number < 3) {
      number = 3;
    }
    if (number > 5) {
      number = 5;
    }
    return `${assetsUrl}/svg/groupe_${number}.svg`;
  }
}
